import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { isEmpty } from 'lodash'

import BulkSelectionContext from 'contexts/BulkSelectionContext'

const EMPTY_ITEMS = []

const BulkSelectionProvider = ({ items = EMPTY_ITEMS, children }) => {
  const [selected, setSelected] = useState([])

  const selectedIds = useMemo(() => new Set(selected), [selected])

  const allSelected = !isEmpty(items) && selected.length === items?.length
  const someSelected = !isEmpty(selected) && !allSelected

  const isSelected = useCallback(
    (itemId) => selectedIds.has(itemId),
    [selectedIds],
  )

  const toggle = useCallback(
    (itemId) =>
      setSelected((previousSelected) =>
        previousSelected.includes(itemId)
          ? previousSelected.filter((selectedId) => selectedId !== itemId)
          : [...previousSelected, itemId],
      ),
    [],
  )

  const toggleAll = useCallback(
    () =>
      setSelected((previousSelected) =>
        previousSelected.length === items?.length
          ? []
          : items.map((item) => item?.id),
      ),
    [items],
  )

  useEffect(() => {
    setSelected((previousSelected) =>
      isEmpty(previousSelected) ? previousSelected : [],
    )
  }, [items])

  const value = useMemo(
    () => ({
      items,
      selected,
      setSelected,
      isSelected,
      toggle,
      toggleAll,
      allSelected,
      someSelected,
    }),
    [items, selected, isSelected, toggle, toggleAll, allSelected, someSelected],
  )

  return (
    <BulkSelectionContext.Provider value={value}>
      {children}
    </BulkSelectionContext.Provider>
  )
}

export default BulkSelectionProvider
